import Messages, { MessagesState, MessagesViewModel } from "./Messages";
import { FromStore } from "../../helpers/Store";
import { DeclareState } from "../../helpers/State";
import { useAppDispatch } from "../../helpers/UseAppDispatch";
import { useEffect } from "react";
import { ResetMessage } from "../../stores/page/actions";

const MessagesInPage: React.FunctionComponent = () => {
	const _duration = FromStore(x => x.page.MessageDuration);
	const _call = FromStore(x => x.page.MessageCall);
	const dispatch = useAppDispatch();
	const _state = DeclareState<MessagesState>({
		message: '',
		open: false,
		type: 'success'
	});

	const _viewModel = new MessagesViewModel(_state);

	useEffect(() => {
		if (_call === null) {
			return;
		}
		_call(_viewModel);
		dispatch(ResetMessage());
	}, [_call]);

	function render(): JSX.Element {
		return <Messages duration={_duration} state={_viewModel} />

	}

	return render();
}


export default MessagesInPage;